import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKeys =
	| 'moreMenuRenameLabel'
	| 'moreMenuDeleteLabel'
	| 'moreBtnLabel'
	| 'renameInputLabel'
	| 'confirmRenameLabel'
	| 'cancelRenameLabel';

const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	moreMenuRenameLabel: {
		id: 'rovo-platform-ui-components.chat-list.moreMenuRenameLabel',
		defaultMessage: 'Rename',
		description:
			'Label for the rename action in the more-menu popup of a chat list item. Shown as clickable text in a dropdown menu. When clicked, it replaces the list item with an inline rename form.',
	},
	moreMenuDeleteLabel: {
		id: 'rovo-platform-ui-components.chat-list.moreMenuDeleteLabel',
		defaultMessage: 'Delete',
		description:
			'Label for the delete action in the more-menu popup of a chat list item. Shown as clickable text in a dropdown menu. When clicked, it triggers deletion of the conversation.',
	},
	moreBtnLabel: {
		id: 'rovo-platform-ui-components.chat-list.moreBtnLabel',
		defaultMessage: 'More actions',
		description:
			'Accessible label for the more-menu trigger button on a chat list item. Used by screen readers to announce the purpose of the three-dot button.',
	},
	renameInputLabel: {
		id: 'rovo-platform-ui-components.chat-list.renameInputLabel',
		defaultMessage: 'Edit chat name',
		description:
			'Accessible label for the text input field that appears when a user renames a chat conversation. Used by screen readers.',
	},
	confirmRenameLabel: {
		id: 'rovo-platform-ui-components.chat-list.confirmRenameLabel',
		defaultMessage: 'Confirm rename',
		description:
			'Accessible label for the confirm button in the rename form. Used by screen readers.',
	},
	cancelRenameLabel: {
		id: 'rovo-platform-ui-components.chat-list.cancelRenameLabel',
		defaultMessage: 'Cancel rename',
		description:
			'Accessible label for the cancel button in the rename form. Used by screen readers.',
	},
});

export default messages;
